import { Box, Grid, Stack, styled, Typography } from "@mui/material";
import { useRouter } from "next/router";
import React, { useContext, useEffect, useRef, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { primary } from "../../constants/theme";
import { Context } from "../../context/context";
import NoDescriptionPopUp from "../../Popups/NewVehiclePopUp/NewVehiclePopUp";
import VehicleListPop from "../../Popups/vehicleCarouselPopUp/VehicleListPop";
import { MemoizedButton } from "../../SDK/button";
import { sendAnalytics } from "../../utils/analyticsCommon";
import { useMobile } from "../../utils/findViewport";
const CustomerVehicleCard = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  width: "100%",
  minHeight: "300px",
  maxHeight: "600px",
  maxWidth: "400px",
  padding: "10px",
  flexDirection: "column",
  background:
    "linear-gradient(180deg, rgba(242, 242, 242, 0.5) 0%, rgba(53, 191, 104, 0.22) 100%)",
  borderRadius: "0.5em",
  marginBottom: "30px",

  ".grid-container": {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginTop: "8px",
    marginBottom: "8px",
  },
  ".grid-item-style": {
    display: "flex",
    justifyContent: "center",
    margin: "5px",
  },
  ".subHeader": {
    fontSize: "14px",
    fontWeight: "500",
    color: primary.mainText,
    marginTop: "8px",
  },
  ".vehicle_name_heading": {
    fontWeight: "600",
    fontSize: "20px",
    textAlign: "left",
    position: "relative",
    top: "-41.6px",
    left: "-8px",
    textTransform: "capitalize",
  },
  ".subHeaderDetails": {
    fontSize: "24px",
    fontWeight: "600",
    marginBottom: "8px",
    color: primary.mainText,
  },
  ".vehicleDetails": {
    background: primary.white,
    borderRadius: "8px",
    padding: "10px",
    paddingLeft: "10px",
    paddingRight: "10px",
    minWidth: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  ".vehicleDetailsHeader": {
    fontSize: "14px",
    color: primary.greyText,
    fontWeight: 600,
    textTransform: "capitalize",
    alignItems: "flex-start",

    textAlign: "center",
  },
  ".vehicleDetailsdata": {
    fontSize: "16px",
    fontWeight: 700,
    alignItems: "flex-end",
  },
  ".testDriveCta": {
    borderRadius: "6px",
    marginTop: "12px",
    background: primary.white,
    color: "#F63B63",
    border: `1px solid ${primary.main}`,
    boxShadow: "none",
    textTransform: "capitalize",
    fontSize: "20px",
    fontWeight: "600",

    letterSpacing: "0em",
    textAlign: "center",
    "&:hover": {
      color: primary.white,
      background: primary.main,
    },
  },
  [theme.breakpoints.down("md")]: {
    // maxWidth: "400px",
    width: "100% !important",

    marginBottom: "30px",
    padding: "12px",

    ".subHeader": {
      fontSize: "12px",
    },
    ".subHeaderDetails": {
      fontSize: "24px",
    },

    ".vehicleName": {
      fontSize: "14px",
    },

    ".testDriveCta": {
      fontSize: "20px",
      paddingBlock: "8px !important",
      color: primary.white,
      background: primary.main,
      "&:hover": {
        color: primary.main,
        background: primary.white,
      },
    },
  },
  [theme.breakpoints.down("sm")]: {
    ".vehicle_name_heading": {
      left: "-0px",
    },
  },
}));
const VehicleCard2 = ({ vehicleData, isNewVehicle, ctaText }) => {
  const state = useContext(Context);

  const mobile = useMobile();

  const { showVehicleListDrawer, showLoanPopup } = useContext(Context);
  const navigate = useRouter();
  const [showPopUp, setShowPopUp] = useState(false);

  const targetRef = useRef(null);

  const [showVehiclePopUp, setShowVehiclePopUp] = useState(false);
  const handlePopUpClose = (s) => {
    setShowPopUp(false);
  };
  const handleVehiclePopUpClose = (e) => {
    setShowVehiclePopUp(false);
  };

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.8,
    };

    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;

      if (entry.isIntersecting) {
        sendAnalytics(`vehicle_${vehicleData?.vehicle_name}`, {}, "en");
      }
    }, options);

    if (targetRef.current) observer.observe(targetRef.current);

    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      if (targetRef.current) observer.unobserve(targetRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetRef]);

  return (
    <CustomerVehicleCard>
      {showPopUp && (
        <NoDescriptionPopUp
          open={true}
          onClose={handlePopUpClose}
          vehicleData={vehicleData}
        />
      )}

      {showVehiclePopUp && (
        <VehicleListPop
          open={true}
          onClose={handleVehiclePopUpClose}
          vehicleData={vehicleData}
        />
      )}

      <Typography
        variant="h3"
        className="vehicle_name_heading"
        id={vehicleData?.vehicle_name}
        ref={targetRef}
      >
        {vehicleData?.brand} {vehicleData?.vehicle_name}
      </Typography>
      <Grid Container className="grid-container">
        <Grid item xs={8} className="grid-item-style">
          <Stack style={{ width: "100%", height: "190px", minHeight: "170px" }}>
            <LazyLoadImage
              src={vehicleData?.homeImage || vehicleData?.storeImage}
              fetchpriority={"high"}
              alt={`${vehicleData?.brand} images`}
              visibleByDefault={true}
              loading="lazy"
              onClick={() => {
                let payload = {
                  vehicle_id: vehicleData?.id,
                  vehicle_name: vehicleData?.name,
                };
                sendAnalytics(
                  "v2_view_vehicle_image_drawer_open",
                  payload,
                  "en"
                );
                mobile
                  ? showVehicleListDrawer(vehicleData)
                  : setShowVehiclePopUp(true);
              }}
            />
          </Stack>
        </Grid>
        <Grid
          item
          xs={4}
          className="grid-item-style"
          flexDirection={"column"}
          style={{ justifyContent: "flex-start", alignItems: "end" }}
        >
          <Stack sx={{ width: "80px" }}>
            <LazyLoadImage
              style={{ minHeight: "10px" }}
              fetchpriority={"high"}
              visibleByDefault={true}
              src={vehicleData?.vehicle_logo}
              alt={vehicleData?.brand}
            />
          </Stack>
        </Grid>
      </Grid>
      {/* gallery */}
      <Grid
        Container
        style={{
          height: "60px",
        }}
        className="grid-container"
      >
        <Grid
          item
          xs={6}
          className="grid-item-style"
          style={{ justifyContent: "flex-start" }}
        >
          <Stack sx={{ width: "80px", justifyContent: "flex-start" }}>
            <LazyLoadImage
              fetchpriority={"high"}
              src={vehicleData?.galleryIcon || vehicleData?.image}
              visibleByDefault={true}
              alt={vehicleData?.storeImageAltName}
              style={{ cursor: "pointer", minHeight: "10px" }}
              onClick={() => {
                let payload = {
                  vehicle_id: vehicleData?.id,
                  vehicle_name: vehicleData?.name,
                };
                sendAnalytics(
                  "v2_view_vehicle_image_drawer_open",
                  payload,
                  "en"
                );
                mobile
                  ? showVehicleListDrawer(vehicleData)
                  : setShowVehiclePopUp(true);
              }}
            />
          </Stack>
        </Grid>
        <Grid
          item
          xs={8}
          className="grid-item-style"
          flexDirection={"column"}
          style={{ alignItems: "end" }}
        >
          <Stack>
            <Typography className="subHeader">EMI Starting From</Typography>
            <Typography className="subHeaderDetails">
              ₹
              {vehicleData?.prices[
                "Others"
              ]?.full_body?.emiPrice.toLocaleString("en-IN")}
              /- p.m.
            </Typography>
          </Stack>
        </Grid>
      </Grid>

      {/* vehicleDetails  */}
      <Grid Container className="grid-container" rowSpacing={2}>
        <Grid xs={4} item className="grid-item-style">
          <Stack className="vehicleDetails">
            <Typography className="vehicleDetailsHeader">Top Range</Typography>
            <Typography className="vehicleDetailsdata">
              {vehicleData?.range}
            </Typography>
          </Stack>
        </Grid>
        <Grid xs={4} item className="grid-item-style">
          <Stack className="vehicleDetails">
            <Typography
              className="vehicleDetailsHeader"
              style={{ fontSize: "13.9px" }}
            >
              {vehicleData?.type === "passenger"
                ? "Cost/100km"
                : "Load Capacity"}
            </Typography>

            <Typography className="vehicleDetailsdata">
              {vehicleData?.type === "passenger"
                ? vehicleData?.costPer100Km
                : vehicleData?.load}
            </Typography>
          </Stack>
        </Grid>
        <Grid xs={4} item className="grid-item-style">
          <Stack className="vehicleDetails">
            <Typography className="vehicleDetailsHeader">Top Speed</Typography>
            <Typography className="vehicleDetailsdata">
              {vehicleData?.topSpeed}
            </Typography>
          </Stack>
        </Grid>
      </Grid>

      {/* view vehicles button */}
      <MemoizedButton
        className="testDriveCta"
        idlocal={`testDriveCta`}
        content={ctaText}
        handleClick={() => {
          let payload = {
            vehicle_id: vehicleData?.id,
            vehicle_name: vehicleData?.name,
          };
          sendAnalytics("v2_view_vehicle", payload, "en");
          sendAnalytics(
            "v2_loan_card_lead_form_opened",
            { type: "v2_view_vehicle", ...payload },
            "en"
          );

          const loanPayload = {
            brand: vehicleData?.brand,
            formTrigger: "v2_view_vehicle_listing",
            vehicle_id: vehicleData?.vehicle_path_id,
            vehicle_type:vehicleData?.type
          };

          if (localStorage?.getItem("phoneInfo") === null) {
            showLoanPopup(loanPayload);
          } else {
            const navigationUrl =
              vehicleData?.type === "passenger"
                ? `/electric-passenger-vehicles/${vehicleData?.brand}/${vehicleData?.vehicle_path_id}` :
                (
                 vehicleData?.type === "cargo4wheeler"
                 ? `/electric-commercial-vehicles/4w/${vehicleData?.brand}/${vehicleData?.vehicle_path_id}`
                  : `/electric-commercial-vehicles/${vehicleData?.brand}/${vehicleData?.vehicle_path_id}`
                )
                // : `/electric-commercial-vehicles/${vehicleData?.brand}/${vehicleData?.vehicle_path_id}`;
            navigate.push(navigationUrl);
          }
        }}
      />
    </CustomerVehicleCard>
  );
};

const MemoizedCustomerVehicleCard = React.memo(VehicleCard2);
export default MemoizedCustomerVehicleCard;
